import { useQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import { queryApiKeyWithServiceProducts } from "./ApiKeyStore";
import {
  ApiKeyWithServiceProducts_publicApi_PublicApi_apiKeys_ApiKeyControlViewModel_apiKey_ApiKeyViewModel as ApiKeyData,
  ApiKeyWithServiceProducts,
  ApiKeyWithServiceProductsVariables
} from "./schema/ApiKeyWithServiceProducts";

export const useApiKey = (apiKeyId: string) => {
  const { data, loading, error } = useQuery<
    ApiKeyWithServiceProducts,
    ApiKeyWithServiceProductsVariables
  >(queryApiKeyWithServiceProducts, {
    variables: { id: apiKeyId }
  });

  const [apiKey, setApiKey] = useState<ApiKeyData | null>(null);

  useEffect(() => {
    if (data && data.publicApi.apiKeys.apiKey) {
      setApiKey(data.publicApi.apiKeys.apiKey);
    }
  }, [data]);

  return { apiKey, loading, error };
};
